import {
  bedtimeMenuItem,
  jpMenuItemData,
  menuItemData,
} from "../constants";
import { MarketType, SourceType } from "../../../types";

export default function buildMenuItems(
  market: MarketType | undefined,
  source: SourceType | null,
) {
  const menuItems = [
    ...(market === "JP" ? jpMenuItemData : menuItemData),
  ];

  if (market === "HK" && source === SourceType.ClubApp)
    menuItems.splice(2, 0, bedtimeMenuItem);

  return menuItems;
}
